export const SIZE = {
  small: 'small',
  big: 'big',
};

export const KIND = {
  input: 'onlyInput',
};


export const accountTypes = [
  {
    label:"Ahorros",
    value:"ahorros"
  },
  {
    label:"Corriente",
    value:"corriente"
  }
];

export const docTypes =[
  {
    label: 'Cédula de ciudadanía',
    value: 'CC',
  },
  {
    label: 'Pasaporte',
    value: 'PPN',
  },
  {
    label: 'Cédula de extranjería',
    value: 'CE',
  },
  {
    label: 'Número de Seguridad Social',
    value: 'SSN',
  },
  {
    label: 'Tarjeta de identidad',
    value: 'TI',
  },
  {
    label: 'Número de Identificación Tributaria',
    value: 'NIT',
  },
  {
    label: 'Sociedad Extranjera sin NIT',
    value: 'SE',
  },
  {
    label: 'Fideicomiso',
    value: 'FID',
  }
];
